import { render, staticRenderFns } from "./RedactorReviewModal.vue?vue&type=template&id=1522164f&scoped=true&"
import script from "./RedactorReviewModal.vue?vue&type=script&lang=js&"
export * from "./RedactorReviewModal.vue?vue&type=script&lang=js&"
import style0 from "./RedactorReviewModal.vue?vue&type=style&index=0&id=1522164f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522164f",
  null
  
)

export default component.exports